import { ref } from 'vue';

export const isTestEnv = (): boolean => import.meta.env.VUE_APP_IS_TEST === 'TEST';

export const skipSecurity = ref(isTestEnv() && sessionStorage.getItem('skipSecurity') === '1');
export const toggleSkipSecurity = (): void => {
  if (!isTestEnv()) {
    return;
  }
  skipSecurity.value = !skipSecurity.value;
  sessionStorage.setItem('skipSecurity', skipSecurity.value ? '1' : '0');
};
